import React, {useEffect, useState} from 'react'
import {
    DEFAULT_DESIGN_VARIANT_STATUS,
    DESIGN_EDITOR_TABS_LIST,
    DESIGN_KEY_PREFIX, DESIGN_VARIANT_STATUS_LIST, TEXT_TABS_LIST
} from "../../constants/design.constant";
import _ from 'lodash'
import {PRODUCT_SIZE_FILTER_LIST} from "../../../pod/constants/pod.constant";

const DESIGN_VARIANT_STATUS_MAP = _.keyBy(DESIGN_VARIANT_STATUS_LIST, 'key');

const ShowDesignVariantStatus = ({designVariantDetail}) => {
    return (
        <>
            {designVariantDetail?.status === 'in-design' &&
                <div className={`pill pill-gray`}>
                    {DESIGN_VARIANT_STATUS_MAP[designVariantDetail?.status]?.label}
                </div>
            }

            {designVariantDetail?.status === 'ready-to-publish' &&
                <div className={`pill pill-green`}>
                    {DESIGN_VARIANT_STATUS_MAP[designVariantDetail?.status]?.label}
                </div>
            }

            {designVariantDetail?.status === 'published' &&
                <div className={`pill pill-purple`}>
                    {DESIGN_VARIANT_STATUS_MAP[designVariantDetail?.status]?.label}
                </div>
            }

            {!designVariantDetail?.status && DEFAULT_DESIGN_VARIANT_STATUS?.color &&
                <div className={`pill pill-gray`}>
                    {DEFAULT_DESIGN_VARIANT_STATUS?.label}
                </div>
            }
        </>
    )
}

export default ShowDesignVariantStatus
